"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoHeaderCont = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SsoHeaderCont = styled_components_1.default.div `
  ${({ theme: { isDesktop } }) => isDesktop && `box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.10)`};
  button {
    padding: 5px;
  }
`;
